import { Box, HStack, VStack, Text } from "@chakra-ui/react";

const SectionCard = ({ icon, title, subtitle, children }) => (
    <Box w="full" bg="bg.card" border="1px solid" borderColor="border.primary" borderRadius={12} p={5}>
        <HStack mb={5} gap={3} align="center">
            <Box bg="bg.dark" borderRadius={8} p={2} color="text.grey" display="flex">
                {icon}
            </Box>
            <VStack align="flex-start" gap={0}>
                <Text color="white" fontWeight={700} fontSize="md">{title}</Text>
                {subtitle && <Text color="text.grey" fontSize="sm">{subtitle}</Text>}
            </VStack>
        </HStack>
        {children}
    </Box>
);

export default SectionCard;
